<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.bookingList') }}
        </div>
        <v-card>
            <v-card-actions class="px-4">
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    append-icon="search"
                    v-model="search"
                    :placeholder="$t('placeholder.searchByBookingNo')"
                    @change="fetchBookings"/>
                <date-range-field
                    class="mx-4"
                    v-model="filterDate"
                    @change="fetchBookings"/>
                <v-btn
                    class="font-weight-regular"
                    color="primary"
                    @click="getBookingReport">
                    <icon
                        class="mr-2"
                        value="file_download"
                        size="18px"/>
                    {{ $t('button.exportXlsx') }}
                </v-btn>
            </v-card-actions>
            <booking-list-view
                class="bookingListView"
                :bookings="bookings"
                :pagination="pagination"
                @booking:sort="onBookingSort"/>
        </v-card>

        <v-pagination
            v-show="showPagination"
            class="pt-2"
            :style="{
                marginRight: '-8px',
            }"
            :value="page"
            :length="pageTotal"
            :total-visible="totalVisible"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>
import BookingListView from '@/views/BookingListView'
import PaginationMixin from '@/mixins/PaginationMixin'
import DateRangeField from '@/components/fields/DateRangeField'

import { mapState } from 'vuex'

export default {
    name: 'BookingListPage',

    mixins: [PaginationMixin],

    components: {
        BookingListView,
        DateRangeField
    },

    data () {
        return {
            search: '',
            filterDate: []
        }
    },

    computed: {
        ...mapState('booking', ['bookings', 'total'])
    },

    mounted () {
        this.fetchBookings()
    },

    methods: {
        fetchBookings () {
            this.$store.dispatch(
                'booking/fetchBookings',
                this.getQueryObject()
            )
        },

        getBookingReport () {
            const { page, itemsPerPage, ...reportQuery } = this.getQueryObject()
            this.$store.dispatch(
                'booking/getBookingReport',
                reportQuery
            )
        },

        getQueryObject () {
            return {
                page: this.page,
                itemsPerPage: this.itemsPerPage,
                sortBy: this.sortBy,
                sortType: this.sortType,
                id: this.search !== '' ? this.search : undefined,
                from: this.filterDate.length === 2 ? this.filterDate[0] : undefined,
                to: this.filterDate.length === 2 ? this.filterDate[1] : undefined
            }
        },

        onPaginationChanged (value) {
            this.page = value
            this.fetchBookings()
        },

        onBookingSort (sortBy, sortType) {
            //  TODO:
            //  This is fast implement
            //      change the mapping field in frontend to be the same as the database
            const fieldMap = {
                bookingDate: 'createdAt',
                travelDate: 'visitDate'
            }
            this.sortBy = fieldMap[sortBy] ?? null
            this.sortType = sortType ?? null
            this.fetchBookings()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
